<template>
    <div class="body d-flex py-lg-3 py-md-2 mb-3">
        <div class="container-xxl">
            <h1 class="page-title  d-none">Λίστα Κατηγοριών</h1>
            <div class="row clearfix g-3">
                <div class="d-flex justify-content-between btngroupdiv">
                    <div class="btn-group" role="group" aria-label="Φίλτρα κατηγοριών">
                        <!-- <button
                            type="button"
                            class="btn"
                            :class="filterStatus === 'all' ? 'btn-primary' : 'btn-outline-primary'"
                            @click="filterStatus = 'all'"
                        >
                            Όλες
                        </button> -->
                        <button
                            type="button"
                            class="btn"
                            :class="filterStatus === 'active' ? 'btn-primary' : 'btn-outline-primary'"
                            @click="filterStatus = 'active'"
                        >
                            Ενεργές
                        </button>
                        <button
                            type="button"
                            class="btn"
                            :class="filterStatus === 'inactive' ? 'btn-primary' : 'btn-outline-primary'"
                            @click="filterStatus = 'inactive'"
                        >
                            Ανενεργές
                        </button>
                        <button
                            type="button"
                            class="btn"
                            :class="filterStatus === 'deleted' ? 'btn-primary' : 'btn-outline-primary'"
                            @click="filterStatus = 'deleted'"
                        >
                            Διαγραμμένες
                        </button>
                    </div>
                    <div class="">
                        <button type="button" class="btn btn-primary" @click="createNewCategory">
                            <i class="icofont-plus text-white"></i> Δημιουργία κατηγορίας
                        </button>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="mb-3">
                        <div class="card-body table-responsive">
                            <table id="clients" class="table table-hover align-middle mb-0 mis_table"
                                style="width:100%">
                                <thead>
                                    <tr>
                                        <th style="width:20%;">
                                            <div>ΚΑΤΗΓΟΡΙΑ</div>
                                        </th>
                                        <th style="width:15%;">
                                            <div>URL</div>
                                        </th>
                                        <th style="width:15%;" v-if="filterStatus !== 'deleted'">
                                            <div>Ενέργειες</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in filteredCategories" :key="index">
                                        <td>{{ item.title }}</td>
                                        <td>{{ item.slug }}</td>
                                        <td class="d-flex justify-content-center" v-if="filterStatus !== 'deleted'">
                                            <div class="d-flex gap-2 align-items-center">
                                                <div><button role="button" @click="editCategory(item)" class="text-success btn">Επεξεργασία</button></div>
                                                <div><button role="button" @click="prepareDeleteCategory(item.id)" class="text-danger btn"><i class="icofont-ui-delete fs-5"></i></button></div>
                                            </div>
                                        </td>
                                    </tr>
                                    
                                    <tr v-if="!categories || !categories.length">
                                        <td colspan="2">Δεν υπάρχουν δεδομένα</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="createCategoryModal" tabindex="-1" aria-labelledby="createCategoryModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-start">Νέα κατηγορία</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="submitCategoryForm">
                        <div class="row">
                            <!-- Title -->
                            <div class="col-md-12 mb-3">
                                <label for="title" class="form-label">Τίτλος</label>
                                <input v-model="categoryForm.title" type="text" class="form-control" id="title"
                                    required />
                            </div>
                            <!-- Slug -->
                            <div class="col-md-12 mb-3">
                                <label for="slug" class="form-label">Slug/URL</label>
                                <input v-model="categoryForm.slug" type="text" class="form-control" id="slug"
                                    required />
                            </div>
                            <!-- Enable -->
                            <div class="col-md-12 mb-3">
                                <label for="enable" class="form-label">Ενεργό</label>
                                <select v-model="categoryForm.enable" class="form-select" id="enable" required>
                                    <option :value="1">Ναι</option>
                                    <option :value="0">Όχι</option>
                                </select>
                            </div>
                            <!-- Background Color -->
                            <div class="col-md-12 mb-3">
                                <label for="bg_color" class="form-label">Χρώμα Φόντου</label>
                                <input v-model="categoryForm.bg_color" type="color"
                                    class="form-control form-control-color" id="bg_color" />
                            </div>
                            <!-- Image Upload (optional) -->
                            <div class="col-md-6 mb-3">
                                <label for="category_img" class="form-label">Φωτογραφία κατηγορίας</label>
                                <div class="d-flex align-items-center">
                                    <img v-if="categoryForm.src && typeof categoryForm.src === 'string' && categoryForm.src.indexOf('img/') !== -1"
                                        :src="`${categoryForm.src}`" width="38" height="38" />
                                    <input ref="categoryImageInput" @change="handleFileUpload" type="file"
                                        class="form-control" id="offer_img" style="margin-left: 10px;" />
                                </div>
                                <div class="form-check mt-2"
                                    v-if="categoryForm.src && typeof categoryForm.src.indexOf == 'function' && categoryForm.src.indexOf('img/') !== -1">
                                    <input v-model="categoryForm.delete_img" class="form-check-input" type="checkbox"
                                        id="delete_img">
                                    
                                    <label class="form-check-label" for="delete_img">
                                        Διαγραφή εικόνας
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-items-end justify-content-end">
                            <button type="submit" class="btn btn-primary">Υποβολή</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="deleteCatModal" tabindex="-1" aria-labelledby="deleteCatModal" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-start">Διαγραφή κατηογρίας</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"
                        aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="submitDeleteCategory">
                        <div>
                            Πρόκειτε να διαγράψετε την κατηγορία. <br>
                            Βεβαιωθείτε ότι είστε σίγουροι για να προχωρήσετε στην διαγραφή της.
                        </div><br>
                        <div class="d-flex align-items-end justify-content-end">
                            <button type="submit" class=" btn btn-danger text-light">Διαγραφή</button>
                        </div>
                        
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { createBusinessCategory, updateBusinessCategory, deleteBusinessCategory } from '@/services/categories';
    import { getBusinessCategories } from '@/services/category';
    import 'vue-toastification/dist/index.css';
    import { useToast } from 'vue-toastification';

    export default {
        name: 'BusinessCategories',
        data() {
            return {
                categories: [],
                filterStatus: 'active',
                categoryForm: {
                    title: '',
                    slug: '',
                    bg_color: null,
                },
                apiData: null,
                error: null,
            };
        },
        computed: {
            filteredCategories() {
                let filtered = [];

                if (this.filterStatus === 'active') {
                filtered = this.categories.filter(cat => cat.enable == 1 && !cat.deleted_at);
                } else if (this.filterStatus === 'inactive') {
                filtered = this.categories.filter(cat => cat.enable == 0 && !cat.deleted_at);
                } else if (this.filterStatus === 'deleted') {
                filtered = this.categories.filter(cat => !!cat.deleted_at);
                } else {
                filtered = this.categories; // 'all'
                }
                filtered.forEach(cat => {
                });
                return filtered.sort((a, b) =>
                    a.title.localeCompare(b.title, 'el', { sensitivity: 'base' })
                );
            }
        },
        watch: {
            filterStatus(newVal) {
            }
        },
        methods: {
            goToCategory(id, slug) {
                this.$router.push(`/category/${id}/${slug}`);
            },
            async fetchCategories() {
                try {
                    const response = await getBusinessCategories();
                    if (response.data.success) {
                    this.categories = response.data.data.sort((a, b) =>
                        a.title.localeCompare(b.title, 'el', { sensitivity: 'base' })
                    );
                    } else {
                    console.error('Failed to fetch categories:', response.data.message);
                    }
                } catch (error) {
                    console.error('Error fetching categories:', error);
                }
            },
            async fetchData() {
                try {
                    // Replace with your actual API URL
                    const response = await getAppInfo();
                    this.apiData = response.data.success ? response.data.data : false;
                } catch (error) {
                    this.error = error.message || 'Error fetching data';
                    console.error(this.error);
                }
            },
            async createNewCategory() {
                this.categoryForm = {
                    id: null,
                    title: '',
                    slug: '',
                    src: null,
                    bg_color: '',
                    enable: 1,
                    src: null,
                };
                $('#createCategoryModal').modal('toggle');
            },
            async submitCategoryForm() {
                const toast = useToast();
                const formData = new FormData();

                formData.append('title', this.categoryForm.title);
                formData.append('slug', this.categoryForm.slug || '');
                formData.append('bg_color', this.categoryForm.bg_color || '#777777');
                formData.append('enable', this.categoryForm.enable ?? 1);

                // Only include src if creating OR if it has changed
                // Detect if we're updating or creating
                const isUpdate = !!this.categoryForm.id;

                if (this.categoryForm.file) {
                    // Append the actual file
                    formData.append('file', this.categoryForm.file);
                    // Also append its name if needed (for preview or Laravel logic)
                    formData.append('src', this.categoryForm.file.name);
                } else if (this.categoryForm.delete_img) {
                    formData.append('delete_img', '1'); // tell backend to delete
                } else if (!isUpdate && this.categoryForm.src) {
                    // For new categories with existing URL-based src
                    formData.append('src', this.categoryForm.src);
                }
                
                // formData.append('src', this.categoryForm.src || '');

                if (this.categoryForm.file) {
                    formData.append('file', this.categoryForm.file);
                }

                try {
                    let response;
                    if (isUpdate) {
                        response = await updateBusinessCategory(this.categoryForm.id, formData);
                    } else {
                        response = await createBusinessCategory(formData);
                    }

                    if (response.data.success) {
                        toast.success(response.data.message);
                        $('#createCategoryModal').modal('hide');
                        this.fetchCategories(); // refresh
                    } else {
                        toast.error(response.data.message || 'Operation failed');
                    }
                } catch (err) {
                    toast.error('Server error or network issue');
                    console.error(err);
                }
            },
            async handleFileUpload(event) {
                const file = event.target.files[0];
                if (!file) return;

                console.log('Selected file:', file); // ← Debug

                this.categoryForm.file = file;
                this.categoryForm.src = file.name;
            },
            editCategory(category) {
                this.categoryForm = {
                    id: category.id,
                    title: category.title || '',
                    slug: category.slug || '',
                    bg_color: category.bg_color || '#777777',
                    enable: category.enable ?? 1,
                    src: category.src || null,
                    file: null, // reset file input
                    delete_img: false, // optionally allow image deletion
                };
                $('#createCategoryModal').modal('show');
            },
            prepareDeleteCategory(id) {
                this.deleteCategoryId = id;
                $('#deleteCatModal').modal('show'); // show the modal
            },
            async submitDeleteCategory() {
            const toast = useToast();
            try {
                const response = await deleteBusinessCategory(this.deleteCategoryId);
                if (response.data.success) {
                toast.success(response.data.message || 'Η κατηγορία διαγράφηκε επιτυχώς');
                $('#deleteCatModal').modal('hide'); // close modal
                this.fetchCategories(); // refresh list
                } else {
                toast.error(response.data.message || 'Αποτυχία διαγραφής');
                }
            } catch (error) {
                toast.error('Σφάλμα δικτύου ή διακομιστή');
                console.error(error);
            }
            }
        },
        mounted() {
            this.fetchData();
            window.addEventListener('beforeinstallprompt', (e) => {
                e.preventDefault();
                this.deferredPrompt = e;
            });
            this.fetchCategories();
        }
    };
</script>

<style scoped>
    @media only screen and (max-width: 600px) {
        .btngroupdiv{
            flex-direction: column;
            align-items: center;
            gap: 15px;
        }
    }
    
</style>